export const capitalizeWords = (value: string | undefined): string => {
  if (!value) return "";

  const exceptions = new Set([
    //pt-br
    "de",
    "do",
    "da",
    "dos",
    "das",
    "e",
    "os",
    "as",
    "para",
    //es
    "del",
    "la",
    "las",
    "los",
    "y",
    "en",
  ]);

  return value
    .toLowerCase()
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word, index) => {
      if (index === 0 || !exceptions.has(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    })
    .join(" ");
};